import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "matirial-filter" }
const _hoisted_2 = { class: "matirial-filter-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "matirial-filter-item-icon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "matirial-filter-item-name PingFangSC-Regular font-12" }

import { MATERIAL } from '@/data/const'
import { useConfAndQueryStore } from '@/store'
import { debounce, throttle } from '@/utils'
import { getMaterialImage } from '@/utils/image'
import { ref, watch } from 'vue'
import { ClickAction } from '@/data/report'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'MaterialFilter',
  props: {
  visible: Boolean,
  contentHidden: Boolean,
  products: Array,
  materials: Array as () => MATERIAL[]
},
  emits: ['select', 'request-hide'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// eslint-disable-next-line no-undef
const props = __props

const { report } = useConfAndQueryStore()
const selected = ref('')

const onMaskClick = throttle(() => {
  emit('request-hide')
})

const onItemClick = debounce((mat: MATERIAL) => {
  selected.value = mat.label === selected.value ? '' : mat.label
  if (selected.value) {
    report(ClickAction.MATERIAL, mat.name)
  }
  emit('select', selected.value)
})

watch(
  () => props.products,
  () => (selected.value = '')
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "matirial-filter-mask",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onMaskClick) && _unref(onMaskClick)(...args)))
    }, null, 512), [
      [_vShow, __props.visible]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["matirial-filter-popup", { visible: __props.visible }]),
      ref: "target"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["matirial-filter-popup-content", { hidden: __props.contentHidden }])
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "matirial-filter-title PingFangSC-Medium lh-23 font-18" }, " 材质 ", -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.materials, (mat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: mat.label,
              class: _normalizeClass({
              'matirial-filter-item': true,
              active: selected.value && selected.value === mat.label,
              disabled: selected.value && selected.value !== mat.label
            }),
              "data-is-touchable": "clickable",
              onClick: _withModifiers(($event: any) => (_unref(onItemClick)(mat)), ["stop"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _unref(getMaterialImage)(mat.image)
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(mat.name), 1)
            ], 10, _hoisted_3))
          }), 128))
        ])
      ], 2)
    ], 2)
  ]))
}
}

})